<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-badge :value="hasFilters" color="#41916b" overlap>
        <template v-slot:badge>
          <v-icon small color="white" style="cursor: pointer" @click.stop="$emit('clear')">
            mdi-close
          </v-icon>
        </template>
        <v-btn class="rounded-lg" elevation="1" color="#aab5b0" v-bind="attrs" v-on="on">
          <v-icon class="mr-2" color="#FFFFFF">mdi-filter</v-icon>
          <span class="textBtn">{{ buttonLabel }}</span>
        </v-btn>
      </v-badge>
    </template>

    <v-card class="rounded-lg">
      <v-list dense class="text-center">
        <span>Selecione os Filtros</span>
      </v-list>
      <div class="overflow-y-auto">
        <v-list>
          <slot></slot>
        </v-list>
      </div>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn small color="#aab5b0" class="rounded-lg" :loading="loadingClear" @click="$emit('clear')" dark>
          {{$t('buttons.clean_up')}}
        </v-btn>
        <v-btn class="rounded-lg" color="#41916b" small dark :loading="loadingSearch" @click="handleSearch">
          <v-icon color="#FFFFFF">mdi-magnify</v-icon>
          {{$t('buttons.search')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'CrudFilter',
  props: {
    hasFilters: { type: Boolean, default: false },
    loadingSearch: { type: Boolean, default: false },
    loadingClear: { type: Boolean, default: false },
  },
  data() {
    return { menu: false };
  },
  computed: {
    buttonLabel() {
      const slots = this.$slots.default || [];
      const count = slots.filter(x => x.tag).length;
      return count > 1 ? 'FILTROS' : 'FILTRO';
    },
  },
  methods: {
    handleSearch() {
      this.menu = false;
      this.$emit('search');
    },
    close() {
      this.menu = false;
    },
  },
};
</script>

<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
</style>
